<template>
  <div
    v-if="isKnown"
    class="app-state"
    :class="'app-state--' + state"
    :style="rootStyle"
    :role="state === 'error' ? 'alert' : 'status'"
  >
    <div class="app-state__inner">
      <template v-if="state === 'loading'">
        <span class="app-spinner app-spinner--24" aria-hidden="true"></span>
        <p class="app-state__text">{{ text || 'Wird geladen …' }}</p>
      </template>
      <template v-else-if="state === 'empty'">
        <app-icon :name="icon || 'file'" :size="22" class="app-state__icon" />
        <div>
          <p class="app-state__title">{{ title || 'Keine Daten' }}</p>
          <p v-if="text" class="app-state__text">{{ text }}</p>
        </div>
        <slot />
      </template>
      <template v-else-if="state === 'error'">
        <div>
          <p class="app-state__title">{{ title || 'Daten konnten nicht geladen werden.' }}</p>
          <p v-if="text" class="app-state__text">{{ text }}</p>
        </div>
        <app-button @click="$emit('retry')">Erneut versuchen</app-button>
      </template>
      <template v-else>
        <app-icon :name="icon || 'lock'" :size="22" class="app-state__icon" />
        <div>
          <p class="app-state__title">{{ title || 'Keine Berechtigung' }}</p>
          <p v-if="text" class="app-state__text">{{ text }}</p>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
// Lade-, Leer- und Fehlerzustand über einem Tabellenkörper oder einer Karte (Spezifikation 2.10).
// Der Behälter braucht position: relative (z. B. .app-grid-fill). state: 'loading' | 'empty' | 'error' | 'forbidden' |
// null. offsetTop (Standard calc(var(--h-th) + 1px)): der Tabellenkopf samt Linie bleibt sichtbar; Zahl = px, Text = CSS-Wert.
// Fehler: title „… konnte nicht geladen werden.“ plus Knopf „Erneut versuchen“ (Ereignis retry).
// Leer: der Default-Slot steht unter dem Text, z. B. „Filter zurücksetzen“ (Verkäufe, Kundenwunsch 12.10.2026).
import AppButton from './AppButton.vue';
import AppIcon from './AppIcon.vue';

const STATES = ['loading', 'empty', 'error', 'forbidden'];

export default {
  name: 'AppStateOverlay',
  components: { AppButton, AppIcon },
  props: {
    state: { type: String, default: null },
    title: { type: String, default: null },
    text: { type: String, default: null },
    icon: { type: String, default: null },
    // unter dem Tabellenkopf samt seiner 1-px-Linie (sie ragt in den Tabellenkörper)
    offsetTop: { type: [Number, String], default: 'calc(var(--h-th) + 1px)' }
  },
  computed: {
    isKnown() {
      return STATES.indexOf(this.state) !== -1;
    },
    rootStyle() {
      const top = this.offsetTop;
      if (typeof top === 'number' || /^\d+(\.\d+)?$/.test(String(top))) {
        return { top: Number(top) + 'px' };
      }
      return { top: String(top) };
    }
  }
};
</script>
